export const MESSAGE_PREFIX = "packages.components.";
